import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Tab, Tabs } from '@mui/material';

import Ticket from './ticket';
import Overview from './overview';
import Evaluations from './evaluations';
import Attendance from './evaluations/attendance';
import Stakeholders from './stakeholders';
import Announcements from './announcements';
import FeedbackInvoice from './feedback-invoice';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Index = ({ currentBatch, setCurrentBatch }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Button variant='outlined' onClick={() => setCurrentBatch(null)}>
        Back
      </Button>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='basic tabs example'>
          <Tab label='Overview' {...a11yProps(0)} value={0} />
          <Tab label='Ticket' {...a11yProps(1)} value={1} />

          <Tab label='Attendance' {...a11yProps(2)} value={2} />
          <Tab label='Evaluations' {...a11yProps(3)} value={3} />
          <Tab label='Stakeholder' {...a11yProps(4)} value={4} />
          {currentBatch.projects?.length > 0 && (
            <Tab label='Announcements' {...a11yProps(5)} value={5} />
          )}
          <Tab label='Feedback And Invoice' {...a11yProps(6)} value={6} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Overview currentBatch={currentBatch} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Ticket batchId={currentBatch._id} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Attendance currentBatch={currentBatch} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Evaluations currentBatch={currentBatch} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Stakeholders batchData={currentBatch} />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <Announcements currentBatch={currentBatch} />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <FeedbackInvoice currentBatch={currentBatch} />
      </TabPanel>
    </Box>
  );
};

export default Index;
